<div>
    <h2>{{ 'welcome.title' | translate }}</h2>
    <br>
    <p>{{ 'welcome.details' | translate }}</p>
    <br>
    <button mat-flat-button color="primary" (click)="onToLogin()" [hidden]="isLoggedIn">{{ 'welcome.login.label' | translate }}</button>
</div>